import { httpPatch } from "../../../network/fetch";
import { AnyOfPalletShipCommand, PalletShipCommandMode } from "./pallet-ship-command";
import { notificationModel } from "../../../component/notifications/notification-model";

export const PalletShipHandler = async (command: AnyOfPalletShipCommand) => {
    try {
        return await httpPatch({
            url: "/pallet/shipMultiple",
            data: {
                ...{
                    palletsIds: command.palletIdList,
                    comment: command.comment,
                },
                ...(command.mode === PalletShipCommandMode.Manual ?
                    {
                        truckIdentifier: command.truckIdentifier,
                        pickingDate: command.pickingDate.utc(true).format(),
                        containerSealNumber: command.containerSealNumber,
                    } : {
                        pickupSlotId: command.pickupSlotId,
                    }),
            },
        });
    } catch (error) {
        notificationModel.addErrorMessage(error.message);

        return false;
    }
};
